/* Nude Project Theme — Product Form JavaScript */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var productForm = document.querySelector('[data-product-form]');
    if (!productForm) return;

    var addBtn = productForm.querySelector('[data-add-to-cart]');
    var sizeButtons = productForm.querySelectorAll('[data-size-option]');
    var colorSwatches = productForm.querySelectorAll('[data-color-swatch]');
    var variantIdInput = productForm.querySelector('[name="id"]');
    var productJson = document.querySelector('[data-product-json]');
    var product = productJson ? JSON.parse(productJson.textContent) : null;

    // Size selection
    sizeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateVariant();
      });
    });

    // Color swatch selection
    colorSwatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        colorSwatches.forEach(function(s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');
        updateVariant();
      });
    });

    function updateVariant() {
      if (!product) return;
      var selectedOptions = [];
      productForm.querySelectorAll('[data-option-group]').forEach(function(group) {
        var selected = group.querySelector('.is-selected, .is-active');
        if (selected) {
          selectedOptions.push(selected.getAttribute('data-value'));
        }
      });

      var matchingVariant = product.variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return !selectedOptions[i] || opt === selectedOptions[i];
        });
      });

      if (matchingVariant) {
        if (variantIdInput) variantIdInput.value = matchingVariant.id;
        // Update URL
        var url = new URL(window.location);
        url.searchParams.set('variant', matchingVariant.id);
        window.history.replaceState({}, '', url);
        // Update price
        var priceEl = document.querySelector('[data-product-price]');
        if (priceEl && window.Theme) {
          priceEl.textContent = window.Theme.formatMoney(matchingVariant.price);
        }
        // Update add to cart
        if (addBtn) {
          addBtn.disabled = !matchingVariant.available;
          addBtn.textContent = matchingVariant.available ? 'ADD TO CART' : 'SOLD OUT';
        }
      }
    }

    // Add to cart
    if (addBtn) {
      addBtn.addEventListener('click', function(e) {
        e.preventDefault();

        // Check size selected
        var hasSizeOption = sizeButtons.length > 0;
        var sizeSelected = productForm.querySelector('[data-size-option].is-selected');
        if (hasSizeOption && !sizeSelected) {
          var sizeGroup = productForm.querySelector('[data-option-group="size"]');
          if (sizeGroup) {
            sizeGroup.style.animation = 'shake 0.5s ease';
            setTimeout(function() { sizeGroup.style.animation = ''; }, 500);
          }
          return;
        }

        var variantId = variantIdInput ? variantIdInput.value : null;
        if (!variantId) return;

        addBtn.classList.add('btn--loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          addBtn.classList.remove('btn--loading');
          addBtn.textContent = 'ADDED ✓';
          addBtn.classList.add('btn--success');

          setTimeout(function() {
            addBtn.textContent = 'ADD TO CART';
            addBtn.classList.remove('btn--success');
          }, 1500);

          document.dispatchEvent(new CustomEvent('product:added', { detail: data }));
          if (window.Theme && window.Theme.Cart) {
            window.Theme.Cart.dispatchUpdate();
          }
        })
        .catch(function(err) {
          addBtn.classList.remove('btn--loading');
          addBtn.textContent = 'Error — Try Again';
          setTimeout(function() { addBtn.textContent = 'ADD TO CART'; }, 2000);
        });
      });
    }

    // Accordion sections
    document.querySelectorAll('.product-accordion__header').forEach(function(header) {
      header.addEventListener('click', function() {
        var section = header.closest('.product-accordion__section');
        var isOpen = section.classList.contains('is-open');
        section.classList.toggle('is-open');
        header.setAttribute('aria-expanded', !isOpen);
      });
    });
  });
})();
